import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys, projectQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useCreateFolderMutation = (options) => {
  const handleMutation = async ({ folderName, parentFolderId }) => {
    const config = {
      method: 'post',
      data: {
        name: folderName,
        parentId: parentFolderId
      }
    }

    const { data } = await api('/api/v2/projectFolders', config)
    return data
  }

  const invalidateRelatedQueries = () => {
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_TREE_QUERY]
    })
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: projectMutationKeys.CREATE_FOLDER,
    retry: 0,
    ...options,
    onSuccess: (data, requestParams, context) => {
      invalidateRelatedQueries()
      // Call user callback with all original parameters
      options?.onSuccess?.(data, requestParams, context)
    },
    onError: (error, requestParams, context) => {
      options?.onError?.(error, requestParams, context)
    }
  })
}
